<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Grade"
      text="Edit Grade"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localGrade.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="localGrade.description"
                v-validate="'max:500'"
                :error-messages="errors.collect('description')"
                :rows="3"
                data-vv-name="description"                
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      grade: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localGrade: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) this.localGrade = { ...this.grade }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.grades().update(this.grade.position_category_id, this.grade.rank_id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          name: this.localGrade.name,
          description: this.localGrade.description,
        }
      },
    },
  }
</script>
